import { render, staticRenderFns } from "./AllGoodsListCx.vue?vue&type=template&id=40c5b9de&scoped=true&"
import script from "./AllGoodsListCx.vue?vue&type=script&lang=js&"
export * from "./AllGoodsListCx.vue?vue&type=script&lang=js&"
import style0 from "./AllGoodsListCx.vue?vue&type=style&index=0&id=40c5b9de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c5b9de",
  null
  
)

export default component.exports